<template>
  <div class="contact">
    <!-- App Title  -->
    <AppTitle></AppTitle>

    <div class="content">

      <div class="content-title">
        <h2>CONTACT</h2>
        <img src="../assets/images/contact2.png" alt="타이틀이미지">
      </div>

      <h3>
        소중한시간 내주셔서 감사합니다<br>
        문의주시면 빠르게 연락드리겠습니다.
      </h3>

      <div class="call_group">
        <!-- box 1 -->
        <div class="box1">
          <img src="../assets/images/phone.png" alt="휴대폰 이미지">
          <div class="text">
            <p>PHONE</p>
            <p>010-5153-4875</p>
          </div>
        </div>

        <!-- box 2 -->
        <div class="box2">
          <img src="../assets/images/mail.png" alt="이메일 이미지">
          <div class="text">
            <p>E-MEILL</p>
            <p>thsdkdud234@naver.com</p>
          </div>
        </div>

        <!-- box 3 -->
        <div class="box3">
          <img src="../assets/images/facebook.png" alt="페이스북 이미지">
          <div class="text">
            <p>FACEBOOK</p>
            <p>thsdkdud123@nate.com</p>
          </div>
        </div>

      </div>




      <form action="form">

        <label for="input_name">name :</label>
        <input type="text" name="name" id="input_name" placeholder="Name">

        <label for="input_phone">phone number</label>
        <input type="text" name="phone" id="input_phone" placeholder="Phone">

        <textarea name="Message" id="input_message" rows="10" placeholder="Message"></textarea>
      </form>

      <button value="SandMassage">SendMassage</button>

    </div>



  </div>
</template>

<!-- SCript Start -->

<script>
import AppTitle from './component/Header.vue';
export default {
  name: "Contact",
  components: {
    AppTitle
  },
  mounted() {
    this.menuAct3();
  },
  methods: {
    menuAct3() {
      $('.Contact').removeClass('menu-act');
      $('.Contact').addClass('menu-act');
    }
  }
}
</script>

<!-- Style Start -->
<style lang="scss" scoped>
@import "../sass/partials/mixin", "../sass/partials/variable";

.contact {
  .content {
    background: url(../assets/images/contact-bg.jpg) no-repeat 60% 0 / cover;
    border-top: 1px solid $m-bg1;
    color: $color1;
    text-align: center;
    padding-bottom: 100px;

    h2 {
      color: $color1;
    }

    h3 {
      @include font-set(bold, 1.7rem, 24px, $ff1 );
      margin-top: 35px;
    }

    .call_group {
      margin-top: 40px;

      >div {
        width: 250px;
        height: 80px;
        @include flex(true, 'space-between', 'center', 0);
        margin: auto;

        img {
          width: 40px;
        }

        .text {
          flex: 1;
          margin-left: 20px;
          text-align: start;
        }
      }
    }

    form {
      width: 302px;
      margin: auto;
      color: $color3;
      margin-top: 82px;
      @include flex(false, 'center', 'center', 0);

      label {
        @include none;
      }

      input {
        width: 100%;
        height: 43px;
        border: 1px solid $b-d2;
        border-radius: 10px;
        text-indent: 10px;
        border-style: none;
        outline-style: none;
        box-shadow: 0 0 3px 3px $b-d2;

        &:nth-child(2) {
          margin: 20px 0;
        }

        &::placeholder {
          @include font-set(bold, 1.5rem, 18px, $ff6);
        }
      }

      textarea {
        width: 100%;
        margin: 20px 0 25px 0;
        border-radius: 10px;
        text-indent: 10px;
        border: none !important;
        box-shadow: 0 0 3px 3px $b-d2;
        border: 1px solid $bd;
        padding: 15px 10px 10px 5px;
        resize: none; // textarea 사이즈조작 none

        &::placeholder {
          @include font-set(bold, 1.5rem, 18px, $ff6);
        }
      }
    }
  }

  button {
    cursor: pointer;
    @include btn-radius(180px, 42px, $bg-color1, 42px);
    border-style: none;
    box-shadow: 0 0 3px 3px $b-d2;

    &:hover {
      background: $bg-color4
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue